/* rr-store.js: store hours, open-now status and the homepage story "Read
   more" (spec v2.17 6H and 6I, 28 Sept 2026). Loaded by the footer, so it
   runs on every page.

   Hours (Mississauga store): Mon, Tue, Thu, Fri 11am to 6pm; Wednesday 11am
   to 7pm; Saturday and Sunday closed. The same week is printed by
   snippets/rr-store-hours.liquid; keep the two in step (assets/rr-card-eta.js
   also has a copy for its "Pickup today" badge).
   Closure days (8 Oct 2026, owner): window.RR_STORE_CLOSED, the ETA holiday
   calendar's onClosed dates (written by sections/footer-classic.liquid). On
   one the line reads "Closed today for the holiday · opens Tuesday 11am",
   and "opens ..." skips them.

   [data-rr-open]  gets .is-open or .is-closed and one line of text:
                   "Open today 11am to 6pm", "Closed now · opens tomorrow 11am",
                   "Closed today · opens Monday 11am" (America/Toronto time)
   [data-rr-hours] its [data-d] cells for today get .is-today (bold)
   [data-rr-legacy-more] opens and closes the story cards (.is-more). */
(function () {
  'use strict';
  var doc = document;
  var HOURS = { 0: null, 1: [11, 18], 2: [11, 18], 3: [11, 19], 4: [11, 18], 5: [11, 18], 6: null };
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function torontoNow() {
    try {
      var parts = {};
      new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Toronto', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      var dow = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[parts.weekday];
      var h = parseInt(parts.hour, 10) % 24;
      return { dow: dow, t: h + (parseInt(parts.minute, 10) || 0) / 60, ymd: [+parts.year, +parts.month, +parts.day] };
    } catch (e) {
      var d = new Date();
      return { dow: d.getDay(), t: d.getHours() + d.getMinutes() / 60, ymd: [d.getFullYear(), d.getMonth() + 1, d.getDate()] };
    }
  }
  /* "YYYY-MM-DD" k days after today (Toronto calendar date) */
  function isoPlus(now, k) {
    var d = new Date(Date.UTC(now.ymd[0], now.ymd[1] - 1, now.ymd[2] + k));
    return d.toISOString().slice(0, 10);
  }
  function closedOn(iso) {
    var list = window.RR_STORE_CLOSED;
    if (!list || !list.length) return false;
    for (var i = 0; i < list.length; i++) { if (String(list[i]).slice(0, 10) === iso) return true; }
    return false;
  }
  function hr(h) {
    if (h === 12) return '12pm';
    return h > 12 ? (h - 12) + 'pm' : h + 'am';
  }

  function status(now) {
    var holiday = closedOn(isoPlus(now, 0));
    var today = holiday ? null : HOURS[now.dow];
    if (today && now.t < today[1]) {
      return { open: true, text: 'Open today ' + hr(today[0]) + ' to ' + hr(today[1]) };
    }
    var lead = holiday ? 'Closed today for the holiday' : (today ? 'Closed now' : 'Closed today');
    for (var k = 1; k <= 14; k++) {
      var d = (now.dow + k) % 7;
      if (HOURS[d] && !closedOn(isoPlus(now, k))) {
        var when = k === 1 ? 'tomorrow' : (k < 7 ? DAYS[d] : DAYS[d] + ' ' + isoPlus(now, k).slice(5).replace('-', '/'));
        return { open: false, text: lead + ' · opens ' + when + ' ' + hr(HOURS[d][0]) };
      }
    }
    return { open: false, text: lead };
  }

  function paint() {
    var now = torontoNow();
    var st = status(now);
    [].slice.call(doc.querySelectorAll('[data-rr-open]')).forEach(function (el) {
      el.classList.toggle('is-open', st.open);
      el.classList.toggle('is-closed', !st.open);
      var t = el.querySelector('span');
      if (t) t.textContent = st.text;
    });
    [].slice.call(doc.querySelectorAll('[data-rr-hours] [data-d]')).forEach(function (el) {
      var days = String(el.getAttribute('data-d')).split(',');
      el.classList.toggle('is-today', days.indexOf(String(now.dow)) !== -1 && !closedOn(isoPlus(now, 0)));
    });
  }

  function legacyMore() {
    doc.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-rr-legacy-more]') : null;
      if (!b) return;
      var box = b.closest('[data-rr-legacy]');
      if (!box) return;
      var open = !box.classList.contains('is-more');
      box.classList.toggle('is-more', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = b.querySelector('.text') || b;
      label.textContent = open ? 'Show less' : 'Read more';
    });
  }

  /* v2.18 6L H2: the footer newsletter band is never empty. When the
     Omnisend embed has not drawn a form 6s after load (blocked, failed, or
     no embed), Shopify's own newsletter form shows instead. */
  function newsletter() {
    var box = doc.querySelector('[data-rr-nl]');
    var fb = box && box.querySelector('[data-rr-nl-fallback]');
    if (!fb || !fb.hasAttribute('hidden')) return;
    var check = function () {
      var embed = box.querySelector('[data-rr-nl-embed]');
      var drawn = embed && embed.querySelector('form, input[type="email"], input[type="text"]');
      if (drawn) return;
      fb.removeAttribute('hidden');
      if (embed) embed.setAttribute('hidden', '');
    };
    var later = function () { setTimeout(check, 6000); };
    if (doc.readyState === 'complete') later();
    else window.addEventListener('load', later);
  }

  /* v2.18 6L G1 + G4: while Shopify's cookie banner is open, html gets
     .rr-cookie-open and --rr-cookie-h (its height plus its 8px gap). The chat
     bubble and the Rewards launcher stay hidden until the choice is made
     (the chat bubble sat on Accept and opened chat instead), and the phone
     sticky bars ride above the banner instead of under it. */
  function cookieWatch() {
    var html = doc.documentElement;
    var last = null;
    var lastV = null;
    var check = function () {
      var b = doc.getElementById('shopify-pc__banner');
      var open = false;
      var h = 0;
      if (b) {
        var cs = window.getComputedStyle(b);
        var r = b.getBoundingClientRect();
        open = cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && !b.hasAttribute('hidden');
        h = open ? Math.round(window.innerHeight - r.top) : 0;
      }
      /* write only on a change: this runs every 500ms while the banner is
         open, and each :root write restyles the page (v7.1 motion review F10) */
      var v = (open ? Math.max(0, h) + 8 : 0) + 'px';
      if (open === last && v === lastV) return;
      last = open;
      lastV = v;
      html.classList.toggle('rr-cookie-open', open);
      html.style.setProperty('--rr-cookie-h', v);
    };
    check();
    if (window.MutationObserver) {
      new MutationObserver(check).observe(doc.body, { childList: true, subtree: false, attributes: false });
    }
    var n = 0;
    var t = setInterval(function () { check(); if (++n > 120) clearInterval(t); }, 500);
    doc.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('#shopify-pc__banner, #shopify-pc__prefs')) setTimeout(check, 350);
    }, true);
  }

  function boot() {
    paint();
    legacyMore();
    newsletter();
    cookieWatch();
    // keep the status honest for a page left open across closing time
    setInterval(paint, 5 * 60 * 1000);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
